import { Directive, ElementRef, HostListener, Input, Renderer2, OnDestroy } from '@angular/core';

@Directive({
  selector: '[bixTooltip]'
})
export class BixTooltipDirective implements OnDestroy {

  toolTipDiv: any;

  @Input() bixTooltip: string = '';

  // takes 4 inputs top, bottom, left, right
  @Input() bixToolTipPosition: string = 'auto';

  @Input() bixToolTipDisable: boolean = false;

  @Input() bixToolTipWrapper;

  constructor(private _renderer: Renderer2, private _el: ElementRef) { }

  @HostListener('mouseenter', ['$event']) mouseover(eventData: Event) {
   
    if (!this.bixToolTipDisable && this.bixTooltip !== '') {

      let toolExits = document.getElementById('bixTooltip');

      if (toolExits == null) {

        let newTooltipDiv = this._renderer.createElement("div");

        newTooltipDiv.classList.add('bix-tooltip');

        newTooltipDiv.id = 'bixTooltip';
        // attaching tooltip text
        newTooltipDiv.innerHTML = this.bixTooltip;


        let tooltipHandleImg = this._renderer.createElement("img");
        tooltipHandleImg.src = 'assets/images/dropdown_circle.svg';

        this._renderer.appendChild(newTooltipDiv, tooltipHandleImg);

        document.body.appendChild(newTooltipDiv);

        // this._renderer.appendChild(this._el.nativeElement, newTooltipDiv); imgMid

        let position = this.getPosition(eventData, this.bixToolTipWrapper ? this.bixToolTipWrapper.offsetHeight : newTooltipDiv.scrollHeight, newTooltipDiv.offsetWidth, newTooltipDiv.scrollHeight);

        let initalizedTooltip = document.getElementById('bixTooltip');

        if (initalizedTooltip !== null) {
          initalizedTooltip.style.top = position.y + 'px';
          initalizedTooltip.style.left = position.x + 'px';

          tooltipHandleImg.style.left = position.imgX + 'px';

          if (position.type === 'top') {
            tooltipHandleImg.style.top = position.imgY + 'px';
            // tooltipHandleImg.classList.add('pos-bottom');
          }
          if (position.type === 'bottom') {
            tooltipHandleImg.style.top = position.imgY + 'px';
            // tooltipHandleImg.classList.add('pos-top');
          }
        }

      } else {
        toolExits.remove();
      }

    }

  }


  getPosition(event: any, toolTipContentHeight: any, toolTipContentWidth: any, toolTipContainerHeight: number = 0) {

    let tooltipYPos: any = 0;
    let tooltipXPos: any = 0;

    let hoverContentRect: any =  this._el.nativeElement.getBoundingClientRect();

    let tooltipPosName: string = '';


    // 4 posibilities left | middle | right | auto
    // TODO: Intoduce 3rd input with name bixHandlePos: 'left' | 'right' | 'middel' | 'auto'
    // Temp Fix : deciding image handle pos on toolTipPos 
    let imgHandleX = hoverContentRect.left + (hoverContentRect.width / 2) - 14;
    let imgHandleY: any = 0;

    // positionX configure
    // Options Available : before | after | middle | auto
    // TODO:  before | after | middle
    switch (this.bixToolTipPosition) {
      case 'right':
        tooltipXPos = hoverContentRect.right - (hoverContentRect.width + 15);
        imgHandleX = hoverContentRect.left + (hoverContentRect.width < 100 ? (hoverContentRect.width - 25) : (toolTipContentWidth - 25));
        break;
      case 'left':
        tooltipXPos = hoverContentRect.left;
        imgHandleX = hoverContentRect.left + 15;
        break;
      case 'top':
      case 'bottom':
      case 'auto':
        if ((toolTipContentWidth / 2) < hoverContentRect.left && (toolTipContentWidth / 2) < hoverContentRect.right) {
          tooltipXPos = hoverContentRect.left + (hoverContentRect.width / 2) - (toolTipContentWidth / 2);
        } else {
          if (hoverContentRect.right > toolTipContentWidth) {
            tooltipXPos = (hoverContentRect.left + (hoverContentRect.width) - (toolTipContentWidth));
          } else {
            tooltipXPos = hoverContentRect.left;
          }
        }
        break;
    }

    // if (this.bixToolTipPosition == 'left') {
      
    // } else
    //   if ((toolTipContentWidth / 2) < hoverContentRect.left && (toolTipContentWidth / 2) < hoverContentRect.right) {
    //     tooltipXPos = hoverContentRect.left + (hoverContentRect.width / 2) - (toolTipContentWidth / 2);
    //   } else {
    //     if (hoverContentRect.right > toolTipContentWidth) {
    //       tooltipXPos = (hoverContentRect.left + (hoverContentRect.width) - (toolTipContentWidth));
    //     } else {
    //       tooltipXPos = hoverContentRect.left;
    //     }
    //   }


    // configuring Y position
    // Options Availble : top | bottom | left | right | auto
    // TODO : left | right
    switch (this.bixToolTipPosition) {
      case 'top':
        tooltipYPos = hoverContentRect.top - toolTipContentHeight - 10;
        imgHandleY = hoverContentRect.top - 25;
        tooltipPosName = 'top';
        break;
      case 'bottom':
        tooltipYPos = hoverContentRect.top + hoverContentRect.height + 10;
        imgHandleY = tooltipYPos - 15;
        tooltipPosName = 'bottom';
        break;
      case 'right':
      case 'left':
      case 'auto':
        if ((window.innerHeight - event.clientY) < toolTipContentHeight + 40) {
          tooltipYPos =  hoverContentRect.top - toolTipContainerHeight - 10;
          imgHandleY = hoverContentRect.top - 25;
          tooltipPosName = 'top';
        } else {
          tooltipYPos =  hoverContentRect.top + (this.bixToolTipWrapper?.offsetHeight ?? hoverContentRect.height) + 10;
          imgHandleY = tooltipYPos - 15;
          tooltipPosName = 'bottom';          
        }
        break;
    }
    // if (this.bixToolTipPosition && (this.bixToolTipPosition === 'top' || this.bixToolTipPosition === 'bottom' || this.bixToolTipPosition === 'left' || this.bixToolTipPosition === 'right')) {

    //   if (this.bixToolTipPosition == 'top') {

    //     tooltipYPos = hoverContentRect.top - toolTipContentHeight - 10;
    //     imgHandleY = hoverContentRect.top - 25;
    //     tooltipPosName = 'top';

    //   }

    //   if (this.bixToolTipPosition == 'bottom') {

    //     tooltipYPos = hoverContentRect.top + hoverContentRect.height + 10;
    //     imgHandleY = tooltipYPos - 15;
    //     tooltipPosName = 'bottom';

    //   }

    //   if (this.bixToolTipPosition == 'left') {
    //     if ((window.innerHeight - event.clientY) < toolTipContentHeight + 40) {
    //       tooltipYPos = hoverContentRect.top - toolTipContentHeight - 10;
    //       imgHandleY = hoverContentRect.top - 25;

    //       tooltipPosName = 'top';
    //     } else {
    //       tooltipYPos = hoverContentRect.top + hoverContentRect.height + 10;
    //       imgHandleY = tooltipYPos - 15;

    //       tooltipPosName = 'bottom';
    //     }
    //   }

    // } else {

    //   // tooltipXPos = hoverContentRect.left + (hoverContentRect.width / 2) - (toolTipContentWidth / 2)
    //   if ((window.innerHeight - event.clientY) < toolTipContentHeight + 40) {
    //     tooltipYPos = hoverContentRect.top - toolTipContentHeight - 10;
    //     imgHandleY = hoverContentRect.top - 25;

    //     tooltipPosName = 'top';
    //   } else {
    //     tooltipYPos = hoverContentRect.top + hoverContentRect.height + 10;
    //     imgHandleY = tooltipYPos - 15;

    //     tooltipPosName = 'bottom';
    //   }

    // }

    return {
      type: tooltipPosName,
      x: tooltipXPos,
      y: tooltipYPos,
      imgX: imgHandleX,
      imgY: imgHandleY
    }
  }



  @HostListener('mouseleave', ['$event'])
  @HostListener('window:scroll', ['$event'])
  @HostListener('window:touchmove', ['$event'])
  @HostListener('window:click', ['$event'])
  closeTooltip(eventData: Event | undefined = undefined) {
    let tooltipDiv = document.getElementById('bixTooltip');
    if (tooltipDiv !== null) {
      this._renderer.removeChild(document.body, tooltipDiv);
    }
  }

  ngOnDestroy() {
    this.closeTooltip();
  }
}


export declare type tooltipPosition = 'top' | 'bottom' | 'left' | 'right' | 'auto';
